<template>
  <div :class="[colSpanClass, props.class, 'mb-2']">
    <slot></slot>
  </div>
</template>
  
  <script setup>
  // ===============================
  // IMPORTS
  // ===============================
  // Vue Core
  import { computed } from 'vue';
  
  // Components
  
  // Composables
  
  // Stores
  
  // Constants and Utils
  
  // ===============================
  // PROPS & EMITS
  // ===============================
    const props = defineProps({
    cols: {
      type: [String, Number],
      default: '12'
    },
    colSpan: {
      type: Object,
      default: null,
    },
    class: {
      type: String,
      default: ''
    }
  });

  // ===============================
  // COMPOSABLES & STORES
  // ===============================
  
  // ===============================
  // REACTIVE STATE
  // ===============================
  
  // ===============================
  // CONSTANTS
  // ===============================
  
  // ===============================
  // COMPUTED PROPERTIES
  // ===============================
  // const colClass = computed(() => {
  //   return props.cols ? `col-md-${props.cols} col-sm-12` : 'col';
  // });

  const colSpanClass = computed(() => {
    if (props.colSpan !== null) {
      const classes = [];
      Object.entries(props.colSpan).forEach(([key, value]) => {
        classes.push(`col-${key}-${value}`);
      });
      return classes.join(' ');
    }
    return props.cols ? `col-md-${props.cols} col-sm-12` : 'col';
  });

  // ===============================
  // METHODS
  // ===============================
  
  // ===============================
  // WATCHERS
  // ===============================
  
  // ===============================
  // LIFECYCLE HOOKS
  // ===============================
  
  // ===============================
  // EXPOSE
  // ===============================

  </script>